import { connect } from 'react-redux';
import TinyWeeklySettlement from '../views/tiny/TinyWeeklySettlement';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyWeeklySettlementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyWeeklySettlement);

export default TinyWeeklySettlementContainer;
